import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import { useNavigate } from 'react-router-dom';
import RightHeaderPage from './rightHeader';

const AdditionalFormPage = () => {
  const navigate = useNavigate();
  const columnDefs = [
    {
      headerName: 'Form Name',
      field: 'formName',
      flex: 2,
      cellRenderer: (params) => (
        <Link href="#" style={{ color: '#2563eb' }}>
          {params.value}
        </Link>
      ),
    },
    { headerName: 'Related State', field: 'relatedState', flex: 1 },
    { headerName: 'Related SIC', field: 'relatedSIC', flex: 1 },
    { headerName: 'Related NAICS', field: 'relatedNAICS', flex: 1 },
    { headerName: 'Related ClassCode', field: 'relatedClassCode', flex: 1 },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: () => (
        <div style={{ display: 'flex', gap: '10px', marginTop: '.8rem' }}>
          {/* Download Icon */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: 'pointer' }}
          >
            <path
              d="M8 1V11M8 11L4 7M8 11L12 7M2 14H14"
              stroke="#000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: 'pointer' }}
          >
            <path
              d="M3 4L13 4M6 4V3C6 2.44772 6.44772 2 7 2H9C9.55228 2 10 2.44772 10 3V4M12 4V13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13V4H12Z"
              stroke="#000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {/* Edit Icon */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: 'pointer' }}
          >
            <path
              d="M11.5 2.5L13.5 4.5M2 13.5V11.5L10.5 3L12.5 5L4 13.5H2Z"
              stroke="#000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      ),
      flex: 1,
    },
  ];

  const rowData = [
    {
      formName: 'Acord Submission',
      relatedState: '',
      relatedSIC: '',
      relatedNAICS: '',
      relatedClassCode: '',
    },
    {
      formName: 'Acord Application',
      relatedState: '',
      relatedSIC: '',
      relatedNAICS: '',
      relatedClassCode: '',
    },
  ];

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className="container-fluid ">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/UnderwritingInformationPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/QuotedPremiumPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Additional Forms
                              <div className=" quote_buttongroup  ">
                                <Button
                                  variant="outline-next"
                                  size="sm"
                                  className="button-icon"
                                  style={{
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 5v14M5 12h14"
                                      className="add_Svg"
                                      stroke="#7C67AD"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                  Add New
                                </Button>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <div className=" quote_buttongroup d-flex justify-content-between mb-2">
                                <h4 className="step-header">Additional Information Forms</h4>
                              </div>

                              <div
                                className="ag-theme-balham quote-grid-style"
                                style={{
                                  height: '300px',
                                  width: '100%',
                                  border: '1px solid #ddd',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                }}
                              >
                                <AgGridReact
                                  columnDefs={columnDefs}
                                  rowData={rowData}
                                  rowSelection="multiple"
                                  pagination={true}
                                  paginationPageSize={10}
                                  domLayout="autoHeight"
                                />
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdditionalFormPage;
